export const Environment = {
  IS_DEV: import.meta.env.DEV,
  BASE_URL: import.meta.env.BASE_URL,

  API: {
    URL: {
      F5_BLURBCORE: import.meta.env.VITE_API_URL_F5_BLURBCORE,
      BLURBCORE: import.meta.env.VITE_API_URL_BLURBCORE,
    },
    JWT_EARLY_TERMINATION_PERIOD: import.meta.env
      .VITE_JWT_EARLY_TERMINATION_PERIOD,
  },
  ENV_NAME: import.meta.env.VITE_ENV_NAME,
  RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  LINK: {
    SUPPORT: import.meta.env.VITE_LINK_SUPPORT,
    BLURBY_REDIRECT: import.meta.env.VITE_LINK_BLURBY_REDIRECT,
    BLURB_TERMS: import.meta.env.VITE_LINK_BLURB_TERMS,
    BLURB_PRIVACY: import.meta.env.VITE_LINK_BLURB_PRIVACY,
    BLURB_SHIPPING: import.meta.env.VITE_LINK_BLURB_SHIPPING,
    BLURB_RETURNS: import.meta.env.VITE_LINK_BLURB_RETURNS,
    BLURB_TAXES: import.meta.env.VITE_LINK_BLURB_TAXES,
    BLURB_LOS: import.meta.env.VITE_LINK_BLURB_LOS,
    BLURBY_FORGOT_PASSWORD: import.meta.env.VITE_LINK_BLURBY_FORGOT_PASSWORD,
  },
  PATH: {
    USER: import.meta.env.VITE_PATH_USER,
    ADMIN: import.meta.env.VITE_PATH_ADMIN,
    PDF_UPLOADER: import.meta.env.VITE_PATH_PDF_UPLOADER,
    IMAGE_UPLOADER: import.meta.env.VITE_PATH_IMAGE_UPLOADER,
    AUTH: import.meta.env.VITE_PATH_AUTH,
  },
  NEWRELIC_CONFIG: {
    AGENT_ID: import.meta.env.VITE_NEWRELIC_AGENT_ID,
    APPLICATION_ID: import.meta.env.VITE_NEWRELIC_APPLICATION_ID,
  },
};
